import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'app-formly-field-date',
  templateUrl: './formly-field-date.component.html',
  styleUrls: ['./formly-field-date.component.scss']
})
export class FormlyFieldDateComponent extends FieldType
{

}
